import { SEASONAL_TEMPORAL_CLASSES } from "@/entities/annualConsumption"

type AnalysisConsumption = ReadonlyArray<{ temporalClass: string; consumption: number }>

export function formatEffyPrefilledElectricityConsumption(
    annualConsumptionByTemporalClass: AnalysisConsumption | null | undefined
) {
    if (!annualConsumptionByTemporalClass) {
        return null
    }

    const prefilled = {} as Record<(typeof SEASONAL_TEMPORAL_CLASSES)[number], number>

    for (const temporalClass of SEASONAL_TEMPORAL_CLASSES) {
        const match = annualConsumptionByTemporalClass.find(
            (item) => item.temporalClass === temporalClass
        )

        if (!match) {
            return null
        }

        prefilled[temporalClass] = match.consumption
    }

    return prefilled
}
